<template>
    <div>
        <v-autocomplete
                v-model="state"
                :label="label"
                :items="stateStore.countryStates"
                item-value="id"
                item-text="fullName"
                outlined
                dense
                :clearable="!readonly"
                @input="save"
                :readonly="readonly"
                :multiple="multiple"
                :chips="multiple"
                :deletable-chips="!readonly"
                :color="inputColor"
                :background-color="backgroundColor"
                :rules="rules"
                hide-details="auto"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>

<script>
import useSharedData from "@/use/SharedData.js";
import {onMounted, ref, watch} from "vue";
import {useCountryStateStore} from "@/stores/CountryState.js";
import axios from "axios";

export default {
    name: "WCountryStateAutocomplete",
    props: {
        value: {
            type: [Number, Array],
            default: () => {
                return null;
            },
        },
        label: String,
        readonly: Boolean,
        multiple: Boolean,
        rules: Array,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();

        const stateStore = useCountryStateStore();


        const state = ref(null);

        watch(() => props.value, () => {
            state.value = props.value;
        }, {immediate: true});

        function save() {
            emit('input', state.value);
        }

        function findAll() {
            loading.value = true;
            axios.get('/countryStates').then(response => {
                stateStore.setCountryStates(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => {
            findAll();
        });

        return {
            loading,
            inputColor,
            backgroundColor,
            state,
            stateStore,
            save,
        }
    }
}
</script>

<style scoped>

</style>